import { Platform } from "@angular/cdk/platform";
import { inject, Injectable } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { PwaInstallPromptComponent } from "./pwa-install-prompt.component";

@Injectable({
	providedIn: "root",
})
export class PwaService {
	private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
	private platform: Platform = inject(Platform);

	public promptEvent: any;
	public mobileType: "android" | "ios";
	public canBeInstalled = false;
	public isInstalled = false;

	initPwaPrompt() {
		if (this.platform.ANDROID || this.platform.BLINK) {
			window.addEventListener("beforeinstallprompt", (event: any) => {
				event.preventDefault();
				this.promptEvent = event;
				this.mobileType = "android";
				this.canBeInstalled = true;
			});
		} else if (this.platform.IOS || this.platform.SAFARI) {
			this.isInstalled = !!(
				"standalone" in window.navigator && window.navigator["standalone"]
			);
			this.canBeInstalled = !this.isInstalled;
			this.mobileType = "ios";
		}
	}

	isInPwaMode(): boolean {
		// Check for iOS PWA mode
		const pwaOnIOS = !!(
			"standalone" in window.navigator && window.navigator["standalone"]
		);

		// Check for PWA mode on Android
		const pwaModes = ["standalone", "fullscreen", "minimal-ui"];
		const pwaOnAndroid = pwaModes.some(
			(mode) => window.matchMedia(`(display-mode: ${mode})`).matches,
		);

		return pwaOnIOS || pwaOnAndroid;
	}

	openPromptComponent() {
		this.bottomSheet.open(PwaInstallPromptComponent, {
			data: { mobileType: this.mobileType, promptEvent: this.promptEvent },
		});
	}
}
